<template>
  <div>
    <el-card>
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="机构名称" prop="name" class="form-bottom">
              <el-input v-model="searchForm.agentName" placeholder="请输入机构名称" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="7">
            <el-row>
              <el-form-item label="成交单量" prop="name" class="form-bottom">
                <el-col :span="11">
                  <el-input v-model="searchForm.minOrderCount" maxlength="10" type="number" placeholder="成交单量下限"></el-input>
                </el-col>
                <el-col :span="2" style="text-align:center;line-height:32px">-</el-col>
                <el-col :span="11">
                  <el-input v-model="searchForm.maxOrderCount" maxlength="10" type="number" placeholder="成交单量上限"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :sm="24" :md="12" :lg="7">
            <el-row>
              <el-form-item label="成交总额" prop="name" class="form-bottom">
                <el-col :span="11">
                  <el-input v-model="searchForm.minTurnover" maxlength="10" type="number" placeholder="成交总额下限"></el-input>
                </el-col>
                <el-col :span="2" style="text-align:center;line-height:32px">-</el-col>
                <el-col :span="11">
                  <el-input v-model="searchForm.maxTurnover" maxlength="10" type="number" placeholder="成交总额上限"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :sm="24" :md="24" :lg="4" style="text-align:right">
            <el-button-group style="float:right">
              <el-button type="primary" style @click="selectPageList()" icon="el-icosn-search">查询</el-button>
              <el-button type="primary" @click="reset()" icon="el-icon-refresh">重置</el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24" style="margin-bottom: 10px;">
        <el-col :span="12">
          <div style="line-height:40px;color:#333;font-size:14px;display: inline;margin-right:20px">
            总成交单量:
            <span style="font-size:14px;font-weight:bold">{{orderListStats.orderCount}}单</span>
          </div>
          <div style="line-height:40px;color:#333;font-size:14px;display: inline;">
            总收益：
            <span style="font-size:14px;font-weight:bold">{{orderListStats.turnover}}元</span>
          </div>
        </el-col>
      </el-row>
      <el-table
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 0px; width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column
          show-overflow-tooltip
          prop="机构等级"
          width="136"
          label="机构等级"
          align="center"
          :render-header="renderSpecNameHeader"
        >
          <!-- <template slot-scope="row">
            <span>{{row.row.distributionLevel}}</span>
          </template> -->
          <template slot-scope="row">
            <span v-if="row.row.distributionLevel.indexOf('合伙人')!==-1" class="purple">{{row.row.distributionLevel}}</span>
            <span
              v-else-if="row.row.distributionLevel.indexOf('金牌')!==-1"
              class="gold"
            >{{row.row.distributionLevel}}</span>
            <span
              v-else-if="row.row.distributionLevel.indexOf('银牌')!==-1"
              class="gray"
            >{{row.row.distributionLevel}}</span>
            <span
              v-else-if="row.row.distributionLevel.indexOf('铜牌')!==-1"
              class="coppery"
            >{{row.row.agentLevel.name}}</span>
            <span v-else class="general">{{row.row.distributionLevel}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="机构名" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderCount" label="成交单量" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop="turnover" label="成交总额（元）" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop="commission" label="代理抽成%" align="center"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="commissionOnTurnover"
          label="弘智收益(元)"
          align="center"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="goodsCount" label="分销商品" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="agentId = scope.row.id,goodsInfoPage.pageNumber=1,goodsInfoPageList()"
            >{{scope.row.goodsCount}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="orderName"
          label="交易记录"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <span
              class="mainColor"
              @click="selection=scope.row.id,userInfoPage.pageNumber=1,agentAmountLogPageList()"
            >查看</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="开通记录"
      :visible.sync="agentAmountLogVisible"
      width="800px"
      left
      :close-on-click-modal="false"
    >
      <el-table
        ref="multipleTable"
        :data="userInfoPage.rows"
        tooltip-effect="dark"
        style="width: 100%;"
        border
      >
        <el-table-column prop="createTime" label="交易时间" width="150" align="center"></el-table-column>
        <el-table-column prop="goodsName" label="开通商品" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="goodsPrice" label="商品原价" width="120" align="center"></el-table-column>
        <el-table-column prop="commissionOnTurnover" label="代理抽成（元）" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        style="margin-top: 20px;text-align: right;"
        :total="userInfoPage.total"
        :page-size="userInfoPage.pageSize"
        :current-page="userInfoPage.pageNumber"
        @size-change="userInfoSizeChange"
        @current-change="userInfoCurrentChange"
      ></el-pagination>
    </el-dialog>

    <el-dialog
      title="分销商品"
      :visible.sync="goodsInfoVisible"
      width="1000px"
      left
      :close-on-click-modal="false"
    >
      <el-table
        ref="multipleTable"
        :data="goodsInfoPage.rows"
        tooltip-effect="dark"
        style="width: 100%;"
        border
        :loading="goodsInfoPageLoading"
      >
        <el-table-column prop="name" show-overflow-tooltip label="商品" width="300">
          <template slot-scope="row">
            <el-row>
              <el-col :span="8">
                <span>
                  <!-- <img :src="row.row.logo" /> -->
                  <img
                    style="margin-right:10px;"
                    width="100%"
                    height="44px"
                    :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                  />
                </span>
              </el-col>
              <el-col :span="16">
                <span
                  style="color:rgb(36, 210, 181);margin-left:10px;"
                  v-if="row.row.recommend=='1'"
                >{{"[推荐]"}}</span>
                <span
                  style="color:rgb(36, 210, 181);margin-left:10px;"
                  v-if="row.row.hot=='1'"
                >{{"[热门]"}}</span>
                <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                <span style="display:block;margin-left:10px;">
                  <span style="color:red">￥{{row.row.price}}</span>
                  <span
                    style="text-decoration:line-through;color:rgb(162,170,188)"
                  >￥{{row.row.originalPrice}}</span>
                </span>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="type"
          width="100"
          align="center"
          label="类型"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="subjectCourseName" label="所属科目" align="center"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="validDay"
          width="100"
          label="有效期"
          align="center"
        >
          <template slot-scope="row">{{row.row.validDay}}天</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="120"
          prop="commissionOnTurnover"
          label="代理抽成（元）"
          align="center"
        >
          <template slot-scope="row">
            <span style="color:red;font-weight:bold">{{row.row.commissionOnTurnover}}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="100"
          prop="stock"
          label="已售出"
          align="center"
        >
          <template slot-scope="row">
            <span>{{row.row.sellCount}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        style="margin-top: 20px;text-align: right;"
        :total="goodsInfoPage.total"
        :page-size="goodsInfoPage.pageSize"
        :current-page="goodsInfoPage.pageNumber"
        @size-change="goodsInfoSizeChange"
        @current-change="goodsInfoCurrentChange"
      ></el-pagination>
    </el-dialog>

    <el-dialog title="订单信息" :visible.sync="payFormVisible" width="800px" left>
      <el-row :gutter="20">
        <el-col :span="24">
          <span style="font-size:14px;font-weight:500;color:#000;">订单信息</span>
          <span
            style="margin-left:20px;"
            class="paid style1"
            v-if="payForm.orderState=='已付款'"
          >{{payForm.orderState}}</span>
          <span
            style="margin-left:20px;"
            class="paid style2"
            v-if="payForm.orderState=='待付款'"
          >{{payForm.orderState}}</span>
          <span
            style="margin-left:20px;"
            class="paid style3"
            v-if="payForm.orderState=='已取消'"
          >{{payForm.orderState}}</span>
          <span
            style="margin-left:20px;"
            class="paid style3"
            v-if="payForm.orderState=='已退款'"
          >{{payForm.orderState}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:20px;">
        <el-col :span="8">
          <span>订单编号：{{payForm.number?payForm.number:''}}</span>
        </el-col>
        <el-col :span="8">
          <span>学员姓名：{{payForm.student?payForm.student.name:''}}</span>
        </el-col>
        <el-col :span="8">
          <span>学员电话：{{payForm.student?payForm.student.mobile:''}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:20px;">
        <!-- <el-col :span="8">
          <span>是否开票：{{payForm.agentId?payForm.agentId:''}}</span>
        </el-col>-->
        <el-col :span="8">
          <span>订单来源：{{payForm.sourceType?payForm.sourceType:''}}</span>
        </el-col>
        <el-col :span="8">
          <span>支付IP：{{payForm.ip?payForm.ip:''}}</span>
        </el-col>
        <el-col :span="8">
          <span>下单时间：{{payForm.createTime?payForm.createTime:''}}</span>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" style="margin-top:20px;">
        <el-col :span="8">
          <span>下单时间：{{payForm.createTime?payForm.createTime:''}}</span>
        </el-col>
      </el-row>-->
      <el-table
        :data="payForm.orderItemList"
        tooltip-effect="dark"
        style="margin-top: 21px; width: 100%;"
        border
      >
        <el-table-column prop="goodsName" label="商品名称"></el-table-column>
        <el-table-column prop="goodsPrice" label="单价"></el-table-column>
        <el-table-column prop="goodsQuantity" label="数量"></el-table-column>
        <el-table-column prop="goodsTotalAmount" label="总价"></el-table-column>
      </el-table>
      <div style="margin-top:20px;font-size:14px;font-weight:500;color:#000;">订单实付金额</div>
      <el-table
        :data="payForm.orderPaymentList"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
      >
        <el-table-column prop="channel" label="支付类型"></el-table-column>
        <el-table-column prop="paymentTime" label="时间"></el-table-column>
        <el-table-column prop="tradeAmount" label="实付金额(元)"></el-table-column>
        <el-table-column prop="tradePaymentAccount" label="付款账户"></el-table-column>
        <el-table-column prop="tradeState" label="状态"></el-table-column>
      </el-table>
      <!-- <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="payFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrderInfo">确 定</el-button>
      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectHeader from "./SelectHeader";

export default {
  data() {
    return {
      checkCampusAgentTrue: false,
      goodsInfoPageLoading: false,
      paidTime: [],
      createTime: [],
      orderStateForm: [],
      orderSourceForm: [],
      orderListStats: {},
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      payFormVisible: false,
      agentAmountLogVisible: false,
      goodsInfoVisible: false,
      loading: false,
      chargebackForm: {
        refundReason: ""
      },
      userInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      searchForm: {
        minTurnover: null,
        maxTurnover: null,
        minOrderCount: null,
        maxOrderCount: null,
        agentName: null
      },
      goodsInfoSearchForm: {},
      goodsInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        agentId: null
      },
      payForm: {
        student: {},
        goodsInfoList: {}
      },
      chargebackFormRules: {
        refundReason: [
          {
            required: true,
            message: "请输入退款理由",
            trigger: "blur"
          }
        ]
      },
      formLabelWidth: "80px",
      selection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/orderInfo/upload`,
      fileList: [],
      loading: true
    };
  },
  methods: {
    checkCampusAgent() {
      this.api.orderInfo.checkCampusAgent().then(result => {
        if (result.success) {
          this.checkCampusAgentTrue = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    renderSpecNameHeader(createElement, { column, $index }) {
      let self = this;

      //该列的绑定数据
      console.log(column);
      //列号
      console.log($index);

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px;margin-left: 30px;"
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label
            }
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "order",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName"
              }
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            }
          })
        ]
      );
    },
    //选择框回调
    selectChange(val) {
      this.pageList(val);
      //写点啥吧
    },
    paidTimeChange() {
      if (this.paidTime) {
        this.searchForm.paidTimeBegin = this.paidTime[0];
        this.searchForm.paidTimeEnd = this.paidTime[1];
      } else {
        this.searchForm.paidTimeBegin = "";
        this.searchForm.paidTimeEnd = "";
      }
    },
    createTimeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    goodsInfoSizeChange(pageSize) {
      this.goodsInfoPage.pageSize = pageSize;
      this.goodsInfoPageList();
    },
    goodsInfoCurrentChange(pageNumber) {
      this.goodsInfoPage.pageNumber = pageNumber;
      this.goodsInfoPageList();
    },
    userInfoSizeChange(pageSize) {
      this.userInfoPage.pageSize = pageSize;
      this.agentAmountLogPageList();
    },
    userInfoCurrentChange(pageNumber) {
      this.userInfoPage.pageNumber = pageNumber;
      this.agentAmountLogPageList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    showPayDetail(row) {
      this.payForm = row;
      this.payFormVisible = true;
    },
    goDetail(row) {
      this.$router.push({
        path: "/detials",
        query: {
          id: row.id
        }
      });
    },
    getOrderInfo(row) {
      // this.api.orderInfo
      //   .getOrderInfo({
      //     id: this.selection
      //   })
      //   .then(result => {
      //     this.editForm = result.data;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    agentAmountLogPageList(id) {
      let obj = {
        pageNumber: this.userInfoPage.pageNumber,
        pageSize: this.userInfoPage.pageSize,
        agentId: this.selection
      };
      this.api.agentInfo.distributionPurchasePageList(obj).then(result => {
        if (result.success) {
          this.userInfoPage.rows = [];
          this.userInfoPage.rows = result.data.records;
          this.userInfoPage.total = result.data.total;
          this.agentAmountLogVisible = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },

    selectPageList() {
      if (typeof val == "string") {
        this.searchForm.orderState = val;
      } else {
        this.searchForm.orderState = "";
      }
      this.searchForm.minTurnover = this.stringToNull(this.searchForm.minTurnover);
      this.searchForm.maxTurnover = this.stringToNull(this.searchForm.maxTurnover);
      this.searchForm.minOrderCount = this.stringToNull(this.searchForm.minOrderCount);
      this.searchForm.maxOrderCount = this.stringToNull(this.searchForm.maxOrderCount);
      if(this.searchForm.minTurnover!=null&&this.searchForm.minTurnover){
        this.searchForm.minTurnover = Number(this.searchForm.minTurnover);
      }
      if(this.searchForm.maxTurnover!=null&&this.searchForm.maxTurnover){
        this.searchForm.maxTurnover = Number(this.searchForm.maxTurnover);
      }
      if(this.searchForm.minOrderCount!=null&&this.searchForm.minOrderCount){
        this.searchForm.minOrderCount = Number(this.searchForm.minOrderCount);
      }
      if(this.searchForm.maxOrderCount!=null&&this.searchForm.maxOrderCount){
        this.searchForm.maxOrderCount = Number(this.searchForm.maxOrderCount);
      }
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = 1;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.agentInfo.getOrderCountAndCommissionOnTurnover().then(result => {
        this.orderListStats = result.data;
      });
      this.api.agentInfo
        .distributionStatisticsPageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    goodsInfoPageList() {
      this.goodsInfoPageLoading = true;
      this.goodsInfoSearchForm.pageSize = this.goodsInfoPage.pageSize;
      this.goodsInfoSearchForm.pageNumber = this.goodsInfoPage.pageNumber;
      this.goodsInfoSearchForm.agentId = this.agentId;
      this.api.agentInfo
        .distributionGoodsInfoPageList(this.goodsInfoSearchForm)
        .then(result => {
          this.goodsInfoPageLoading = false;
          this.goodsInfoPage.rows = result.data.records;
          this.goodsInfoPage.total = result.data.total;
          this.goodsInfoVisible = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList(val) {
      // if (typeof val == "number") {
      this.searchForm.distributionLevelId = val;
      // } else {
      //   this.searchForm.distributionLevelId = "";
      // }
      this.searchForm.minTurnover = this.stringToNull(this.searchForm.minTurnover);
      this.searchForm.maxTurnover = this.stringToNull(this.searchForm.maxTurnover);
      this.searchForm.minOrderCount = this.stringToNull(this.searchForm.minOrderCount);
      this.searchForm.maxOrderCount = this.stringToNull(this.searchForm.maxOrderCount);
      if(this.searchForm.minTurnover!=null&&this.searchForm.minTurnover){
        this.searchForm.minTurnover = Number(this.searchForm.minTurnover);
      }
      if(this.searchForm.maxTurnover!=null&&this.searchForm.maxTurnover){
        this.searchForm.maxTurnover = Number(this.searchForm.maxTurnover);
      }
      if(this.searchForm.minOrderCount!=null&&this.searchForm.minOrderCount){
        this.searchForm.minOrderCount = Number(this.searchForm.minOrderCount);
      }
      if(this.searchForm.maxOrderCount!=null&&this.searchForm.maxOrderCount){
        this.searchForm.maxOrderCount = Number(this.searchForm.maxOrderCount);
      }
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.agentInfo.getOrderCountAndCommissionOnTurnover().then(result => {
        this.orderListStats = result.data;
      });
      this.api.agentInfo
        .distributionStatisticsPageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addOrderInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.orderInfo
            .addOrderInfo(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateOrderInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.orderInfo
            .updateOrderInfo(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    reset() {
      // this.$refs.searchForm.resetFields();
      this.searchForm.minTurnover= null;
      this.searchForm.maxTurnover= null;
      this.searchForm.minOrderCount= null;
      this.searchForm.maxOrderCount= null;
      this.searchForm.agentName= null;
      // this.createTime = [];
      // this.paidTime = [];
      // this.searchForm.createTimeBegin = "";
      // this.searchForm.paidTimeBegin = "";
      // this.searchForm.createTimeEnd = "";
      // this.searchForm.studentName = "";
      // this.searchForm.paidTimeEnd = "";
      // this.page = {
      //   rows: [],
      //   total: 0,
      //   pageSize: 10,
      //   pageNumber: 1,
      //   sortName: "",
      //   sortOrder: ""
      // };
      this.selectPageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    getOrderSourceType() {
      this.api.orderInfo.getOrderSourceType().then(result => {
        this.orderSourceForm = result.data;
      });
    },
    getOrderState() {
      this.api.orderInfo.getOrderState().then(result => {
        this.orderStateForm = result.data;
      });
    }
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getOrderInfo();
      }
    }
  },
  mounted() {
    this.pageList();
    // this.getOrderState();
    // this.getOrderSourceType();
  }
};
</script>
<style  scoped>
.el-select {
  width: 100% !important;
}
.paid {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}
.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}
.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}
.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}
.style4 {
  background: rgb(255, 100, 107);
  border: solid 1px rgb(255, 100, 107);
}
</style>


// WEBPACK FOOTER //
// src/components/distributionStatistics/index.vue